import React from 'react';
import CoachProgramListItem from './CoachProgramListItem';
import './CoachProgramList.css';

const CoachProgramList = ({ programs }) => {
  const sortedPrograms = [...programs].sort((a, b) => {
    const aNextSession = a.upcomingSessions?.[0]?.date;
    const bNextSession = b.upcomingSessions?.[0]?.date;

    if (!aNextSession && !bNextSession) return 0;
    if (!aNextSession) return 1;
    if (!bNextSession) return -1;

    return aNextSession.localeCompare(bNextSession);
  });

  if (!programs || programs.length === 0) {
    return (
      <div className="program-list">
        <div className="program-list-header">Upcoming Programs</div>
        <div className="program-list-empty">
          <p>No programs scheduled for you right now.</p>
          <p>Check back soon or reach out to Alanis to sign up for more!</p>
        </div>
      </div>
    );
  }

  return (
    <div className="program-list">
      <div className="program-list-header">Upcoming Programs</div>
      {sortedPrograms.map((program, index) => (
        <CoachProgramListItem key={program.id || index} program={program} />
      ))}
    </div>
  );
};

export default CoachProgramList;